// extracted by mini-css-extract-plugin
export default {"button":"nXufmF9NqTH5QY4YGnB0"};